module.exports = __webpack_public_path__ + "img/edit_pen_hat.5c9a589b.png";